import { Helmet } from "react-helmet-async"
import { Container } from "@sembark-travel/ui/base"
import { TripQuoteEmailTemplates } from "../../../../../EmailPdfTemplates"

export default function OrganizationTemplatesPage() {
	return (
		<>
			<Helmet>
				<title>Quote Email Templates</title>
			</Helmet>
			<Container paddingY="4">
				<TripQuoteEmailTemplates />
			</Container>
		</>
	)
}
